export const colors = {
  bg_primary: "bg-primary",
  bg_secondary: "bg-[#95AFBF]",
  primary_hover: "bg-[#024059]",
  bg_assets: "bg-[#FED06C]",
  bg_light: "bg-[#F2F2F2]",
  text_light: "text-[#F2F2F2]",
  dark_navLink:
    "data-[state=highlight]:dark:text-primary data-[state=highlight]:dark:hover:text-[#F4F4F5] dark:hover:bg-[#202020] dark:hover:text-[#F4F4F5]",
};
